import React, { useState, useContext, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { Form, Button } from 'semantic-ui-react'
import GlobalContext from '../../../contexts/GlobalContext';
import API, { ResponseManagement, ErrorManagement } from '../../../API';
import InputText from '../../FormInputCustomer/InputText/InputText';
import InputSelect from '../../FormInputCustomer/InputSelect/InputSelect';
import Utility from '../../../Utility';
import { toast } from 'react-toastify';
import { SET_USER } from '../../../contexts/GlobalType';
import 'react-toastify/dist/ReactToastify.css';
import './FormAdditionalInformation.css';

const FormAdditionalInformation = (props) => {
  const [globalContext, dispatch] = useContext(GlobalContext);
  const [redirectState, setRedirectState] = useState(false);
  const [errorState, setErrorState] = useState({});
  const [identityDocumentIdState, setIdentityDocumentIdState] = useState(0);
  const [identityDocumentState, setIdentityDocumentState] = useState('');
  const [telephoneState, setTelephoneState] = useState('');
  const [telephoneCodeState, setTelephoneCodeState] = useState('');
  const [mobileState, setMobileState] = useState('');
  const [mobileCodeState, setMobileCodeState] = useState('');
  const [submitAdditionnalInformationsLoaderState, setSubmitAdditionnalInformationsLoaderState] = useState(false);

  useEffect(() => {
    let listInput = getInput();
    let listState = {
      redirect: false,
      error: {}
    };
    
    for (let index in listInput) {// eslint-disable-line no-unused-vars
      let input = listInput[index];
      listState[input.name] = input.valueDefault;
      listState.error[input.name] = false;
    }
    setRedirectState(listState.redirect);
    setErrorState(listState.error);
  }, []);

  useEffect(() => {
    updateDate(globalContext.user);
  }, [globalContext.user]);
  // eslint-disable-line react-hooks/exhaustive-deps

  /**
   * Evenet Submit form
   * @param Object event
   */
  const handleSubmit = async (event) => {

    let dataForm = new FormData(event.target.closest('form')),
      errorTemp = Object.assign({}, errorState),
      errorDetect = false,
      listInput = getInput(),
      data = Object.assign({}, globalContext.user);

    for (let property in globalContext.user) {// eslint-disable-line no-unused-vars
      let newValue = dataForm.get('input_' + property);
      if (newValue !== null) {
        if (property === 'identityDocumentId') {
          newValue = parseInt(newValue);
        }
        data[property] = newValue;
        if( listInput[property].required == true ){
          errorTemp[property] = Utility.checkValue(listInput[property].name, newValue, listInput[property].typePattern);
          if (errorTemp[property].error === true) {
            errorDetect = true;
          }
        }
      }
    }
    
    
    setErrorState(errorTemp);
    updateDate(data);

    if (errorDetect === false) {
      setSubmitAdditionnalInformationsLoaderState(true);
      //data = new URLSearchParams(data);
      API.postForm(Utility.getUrlAjax() + '/updateUserAction', data)
        .then(response => {
          ResponseManagement(response,
            () => {
              updateDate(response.data.data.user);
              dispatch({ type: SET_USER, payload: response.data.data.user });
              //setRedirectState(true);

              if (response.data.data?.nonBlockingErrors?.length > 0) {
                response.data.data.nonBlockingErrors.forEach(errorCode => {
                  toast.warn(globalContext.translations[errorCode]);
                })
              }

              if (response.data.data.message) {
                toast.success(response.data.data.message);
              }

              setSubmitAdditionnalInformationsLoaderState(false);
            },
            () => {
              setSubmitAdditionnalInformationsLoaderState(false);
            }
          );
        })
        .catch(error => {
          console.error(error)
          ErrorManagement(error, () => { });
          setSubmitAdditionnalInformationsLoaderState(false);
        })
    } else {
      toast.error(globalContext.translations.msgErrorEnterAllInput);
    }
  }

  const getInput = () => {
    return {
      identityDocumentId: {
        name: 'identityDocumentId',
        //required: true,
        required: globalContext.fieldResidentParam.resident?.id_type_piece_identite === "mandatory",
        typePattern: 'notNullSelectPays',
        valueDefault: 0,
        disabled: globalContext.fieldResidentParam.resident?.id_type_piece_identite === "mandatory" && identityDocumentIdState != '' && identityDocumentIdState != '00' && identityDocumentIdState != 0 ? props.hasBookingCheckInState.hasBookingCheckIn : false
      },
      identityDocument: {
        name: 'identityDocument',
        //required: true,
        required: globalContext.fieldResidentParam.resident?.id_type_piece_identite === "mandatory",
        typePattern: 'notNull',
        valueDefault: '',
        disabled: globalContext.fieldResidentParam.resident?.id_type_piece_identite === "mandatory" && identityDocumentState != '' ? props.hasBookingCheckInState.hasBookingCheckIn : false
      },
      telephone: {
        name: 'telephone',
        //required: true,
        required: globalContext.fieldResidentParam.resident?.tel === "mandatory",
        typePattern: 'notNull',
        valueDefault: '',
        disabled: globalContext.fieldResidentParam.resident?.tel === "mandatory" && telephoneState != '' ? props.hasBookingCheckInState.hasBookingCheckIn : false
      },
      telephoneCode: {
        name: 'telephoneCode',
        required: false,
        typePattern: false,
        valueDefault: 0
      },
      mobile: {
        name: 'mobile',
        //required: true,
        required: globalContext.fieldResidentParam.resident?.mobile === "mandatory",
        typePattern: 'notNull',
        valueDefault: '',
        disabled: globalContext.fieldResidentParam.resident?.mobile === "mandatory" && mobileState != '' ? props.hasBookingCheckInState.hasBookingCheckIn : false
      },
      mobileCode: {
        name: 'mobileCode',
        //required: true,
        required: globalContext.fieldResidentParam.resident?.mobile === "mandatory",
        typePattern: 'notNull',
        valueDefault: 0,
        disabled: globalContext.fieldResidentParam.resident?.mobile === "mandatory" && mobileCodeState != '' && mobileCodeState != '00' && mobileCodeState != 0 ? props.hasBookingCheckInState.hasBookingCheckIn : false

      }
    }
  }

  const renderRedirectAccount = () => {
    if (redirectState) {
      return <Navigate to={Utility.getUrlPage(globalContext, 'dashboard')} />
    }
  }

  const updateDate = (data) => {
    let errorTemp = Object.assign({}, errorState);
    let listInput = getInput();

    for (let index in listInput) {// eslint-disable-line no-unused-vars
      let input = listInput[index]
      let theValue = data[input.name]

      if( input.required == true ){
        let test = Utility.checkValue(input.name, theValue, input.typePattern)
        //errorTemp[test.target] = test.error

        input.name = test.target
        theValue = test.value
      }


        switch (input.name) {
          case 'identityDocumentId':
            setIdentityDocumentIdState(theValue);
            break;
          case 'identityDocument':
            setIdentityDocumentState(theValue);
            break;
          case 'telephone':
            setTelephoneState(theValue);
            break;
          case 'telephoneCode':
            setTelephoneCodeState(theValue);
            break;
          case 'mobile':
            setMobileState(theValue);
            break;
          case 'mobileCode':
            setMobileCodeState(theValue);
            break;
          default:
            break;
        }
      //setErrorState(errorTemp);
    }
  }

  const listCredentials = [];
  const listIndicatifTel = Utility.getListTelephoneCode(globalContext);

  if (Array.isArray(globalContext.identityDocuments) === true) {
    for (let i = 0; i < globalContext.identityDocuments.length; i++) {
      listCredentials.push({
        key: globalContext.identityDocuments[i].id,
        text: globalContext.identityDocuments[i].name,
        value: globalContext.identityDocuments[i].id,
      });
    }
  }

  let listInput = getInput();

  return (
    <div>
      <Form id="form-additional-information">
        {renderRedirectAccount()}
        <Form.Group widths="equal">
          <InputSelect
            label={globalContext.translations.credentials}
            name={listInput.identityDocumentId.name}
            value={identityDocumentIdState}
            data={listCredentials}
            required={listInput.identityDocumentId.required}
            labelError={globalContext.translations.enterIdTypePieceIdentite}
            typePattern={listInput.identityDocumentId.typePattern}
            error={errorState.identityDocumentId?.error}
            disabled={listInput.identityDocumentId.disabled}
          />
          <InputText
            label={globalContext.translations.numeroPieceIdentite}
            name={listInput.identityDocument.name}
            value={identityDocumentState}
            required={listInput.identityDocument.required}
            labelError={globalContext.translations.enterNumPasseport}
            typePattern={listInput.identityDocument.typePattern}
            error={errorState.identityDocument?.error}
            disabled={listInput.identityDocument.disabled}
          />
        </Form.Group>

        <Form.Group widths="equal">
          <InputText
            label={globalContext.translations.telFixe}
            icon="phone"
            iconPosition="left"
            name={listInput.telephone.name}
            value={telephoneState}
            select={{
              name: listInput.telephoneCode.name,
              value: telephoneCodeState,
              data: listIndicatifTel,
              error: errorState.telephoneCode?.error
            }}
            required={listInput.telephone.required}
            labelError={globalContext.translations.enterIndicatifAndNumberPhone}
            typePattern={listInput.telephone.typePattern}
            error={errorState.tel}
            disabled={listInput.telephone.disabled}
          />
          <InputText
            label={globalContext.translations.telMobile}
            icon="mobile"
            iconPosition="left"
            name={listInput.mobile.name}
            value={mobileState}
            select={{
              name: listInput.mobileCode.name,
              value: mobileCodeState,
              data: listIndicatifTel,
              error: errorState.mobileCode?.error
            }}
            required={listInput.mobile.required}
            labelError={globalContext.translations.enterIndicatifAndNumberPhone}
            typePattern={listInput.mobile.typePattern}
            error={errorState.mobile?.error}
            disabled={listInput.mobile.disabled}
          />
        </Form.Group>

        <Form.Field className="mt-5">
          <Button
            positive
            className="mx-auto d-block"
            onClick={handleSubmit}
            loading={submitAdditionnalInformationsLoaderState}
            disabled={submitAdditionnalInformationsLoaderState}
            content={globalContext.translations.save}
            icon="checkmark"
            labelPosition="right"
          />
        </Form.Field>
      </Form>
    </div>
  );
}

export default FormAdditionalInformation;